import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'expLevel'
})
export class ExperienceLevelPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    switch (value) {
      case 0:
        return 'Beginner';
      case 1:
        return 'Top Rated';
      case 2:
        return 'Top Rated+';
      default:
        return 'Unknown';
    }
  }

}

